import { AxiosError } from "axios";
import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { ResponseError } from "types/dto/ResponseError";
import { RequestAlterarSenha } from "types/request/RequestAlterarSenha";

export const usePostAlterarSenha = (setError: Function, closeModal: Function) => {

  const onSuccess = () => {
    toast.success("Senha alterada com sucesso.");
    closeModal();
  };

  const onError = (error: AxiosError<ResponseError>) => {
    
    setError("senhaAntiga", {
      type: "senhaAnteriorInvalida",
      message: error?.response?.data?.validation[0]?.message,
    });
  };

  return usePost<RequestAlterarSenha>({
    url: api.usuario.postAlterarSenha,
    onSuccess,
    onError,
  });
};
